// extracted by mini-css-extract-plugin
export default {"mario":"Kontakt_mario__zTSfM"};